import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirectComponent } from './components/redirect/redirect.component';
import { ForShoppersComponent } from './components/for-shoppers/for-shoppers.component';
import { HomeComponent } from './components/home/home.component';
import { ForPartnersComponent } from './components/for-partners/for-partners.component';
import { ShopperFaqComponent } from './components/shopper-faq/shopper-faq.component';
import { PartnerFaqComponent } from './components/partner-faq/partner-faq.component';
import { PartnerApplyComponent } from './components/partner-apply/partner-apply.component';
import { PreviewDocumentComponent } from './components/preview-document/preview-document.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { CancelTransactionComponent } from './components/cancel-transaction/cancel-transaction.component';
import { WhereToShopComponent } from './components/where-to-shop/where-to-shop.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { RedirectToPortalComponent } from './components/redirect-to-portal/redirect-to-portal.component';
import { MarketingMaterialComponent } from './components/marketing-material/marketing-material.component';
import { CompetitionsComponent } from './components/competitions/competitions.component';
import { MerchantBenefitsComponent } from './components/merchant-benefits/merchant-benefits.component';
import { AccountDeletionComponent } from './components/account-deletion/account-deletion.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'limit-increase/:idNumber', component: HomeComponent },
  { path: 'apply', component: RedirectComponent },
  { path: 'portal', component: RedirectToPortalComponent },
  { path: 'marketing-material', component: MarketingMaterialComponent },
  { path: 'merchant/signup', component: PartnerApplyComponent },
  { path: 'where-to-shop', component: WhereToShopComponent },
  { path: 'for-shoppers', component: ForShoppersComponent },
  { path: 'for-merchants', component: ForPartnersComponent },
  { path: 'merchant-benefits', component: MerchantBenefitsComponent },
  { path: 'competition', component: CompetitionsComponent },
  { path: 'shopper-faq', component: ShopperFaqComponent },
  { path: 'merchant-faq', component: PartnerFaqComponent },
  // { path: 'merchant-downloads', component: MarketingDownloadsComponent },
  { path: 'preview/:reference', component: PreviewDocumentComponent },
  { path: 'cancel/:key', component: CancelTransactionComponent },
  { path: 'feedback', component: FeedbackComponent },
  { path: 'feedback/:code', component: FeedbackComponent },
  { path: 'feedback/:code/:applicationKey', component: FeedbackComponent },
  { path: 'account-deletion', component: AccountDeletionComponent },
  { path: 'not-found', component: NotFoundComponent },

  // with country code
  // { path: ':country', component: HomeComponent },
  // { path: ':country/limit-increase/:idNumber', component: HomeComponent },
  // { path: ':country/apply', component: RedirectComponent },
  // { path: ':country/portal', component: RedirectToPortalComponent },
  // { path: ':country/merchant/signup', component: PartnerApplyComponent },
  // { path: ':country/where-to-shop', component: WhereToShopComponent },
  // { path: ':country/for-shoppers', component: ForShoppersComponent },
  // { path: ':country/for-merchants', component: ForPartnersComponent },
  // { path: ':country/shopper-faq', component: ShopperFaqComponent },
  // { path: ':country/merchant-faq', component: PartnerFaqComponent },
  // { path: ':country/preview/:reference', component: PreviewDocumentComponent },
  // { path: ':country/cancel/:key', component: CancelTransactionComponent },
  // { path: ':country/feedback', component: FeedbackComponent },
  // { path: ':country/feedback/:code', component: FeedbackComponent },
  // {
  //   path: ':country/feedback/:code/:applicationKey',
  //   component: FeedbackComponent,
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
